import React, {useContext, useEffect, useState} from "react";
import omniscanLogo from "../images/omniscanlogo.png";
import PageHeader from "./components/PageHeader";
import LeftMenu from "./components/LeftMenu";
import NavigationCard from "./components/NavigationCard";
import HeadlineCard from "./components/HeadlineCard";
import {useHistory} from 'react-router-dom';
import db from '../constants/db';
import { store } from "../context/store.js";
import { CHANGE_SELECTED_BUILDING } from "../constants/action-types";

export default function Project(){
	
	const globalState = useContext(store);
  const { dispatch } = globalState;
	
	const history = useHistory();
	
	const[buildings, setBuildings] = useState([]);
	const [projectId, setProjectId] = useState("");
	const [projectCode, setProjectCode] = useState("");
	const [projectName, setProjectName] = useState("");
	const [projectDescription, setProjectDescription] = useState("");
	const [projectPhoto, setProjectPhoto] = useState("");
	
	useEffect(() => {
		const fetchBuildings = async () => {
			
      const all = await db.buildings
	    .where("projectId") 
	    .equals(globalState.state.selectedProject.id)  
	    .toArray();
      setBuildings(all);
    };
		try{
			let project = globalState.state.selectedProject;
			setProjectId(project.id);
			setProjectCode(project.code);
			setProjectName(project.name);
			setProjectDescription(project.description);
			setProjectPhoto(project.photo);
		}
		catch(e){}
    fetchBuildings();
	}, [globalState.state?.selectedProject]);
	
	
	
	const thisContainer = {
			display:'flex',
			flexDirection:"column",
			width:"100vw",
			height:'100vh'
	};
	
	const blankClick = () => {
		
	};

	
	const headlinePanelContainer = {
		display:"flex",
		width:"calc(100% - 0px)",
		marginLeft:"60px", 
		marginTop:"60px"
	};
	
	const projectContainer = {
		display:'flex',
		width:"calc(100% - 60px)",
		marginTop:"10px",
		marginLeft:"60px",
		overflow:"auto",
		alignSelf:"center",
		flexWrap:"wrap"
	};
	
	const getBuilding = (id) => {
		return buildings.find(building => building.id === id);
	};
	
	const selectBuilding = (id) => {
		dispatch({ type: CHANGE_SELECTED_BUILDING, value: getBuilding(id) });
		history.push('/building');
	};
	
	const buildingDisplay = buildings.map((item, index) => 
		<NavigationCard
				id={item.id}
				title={item.name}
				description={item.description}
				clickFunction={selectBuilding}
				photo={item.photo}
		/>
	);
	
	return (
		<div style={thisContainer}>
			<PageHeader
				title="Project Buildings"
			/>
			<LeftMenu/>
			<div style={headlinePanelContainer}>
					<HeadlineCard
						id={projectId}
						title={projectCode + ': ' + projectName}
						description={projectDescription}
						clickFunction={blankClick}
						photo={projectPhoto}
				/>
			</div>
			<div style={projectContainer}>
				{buildingDisplay}
			</div>
		</div>
	);
}